export const IMAGES = {
  heroMain: "https://images.unsplash.com/photo-1502739423516-a7da6332f56f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  heroPrint: "https://images.unsplash.com/photo-1597979732130-9d2ad18df38b?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  heroVideo: "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
  showcaseSignage: "https://images.unsplash.com/photo-1502739423516-a7da6332f56f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  showcaseInterior: "https://images.unsplash.com/photo-1724582586495-d050726cf354?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  showcasePrint: "https://images.unsplash.com/photo-1597979732130-9d2ad18df38b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  showcaseVideo: "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  showcaseOffice: "https://images.unsplash.com/photo-1663811397207-418a92396ad5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  showcaseFacade: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const DEFAULT_CONTENT = {
  hero: {
    overline: "Tam Hizmet Marka Mimarlığı",
    line1: "MARKANIZI",
    line2: "IŞIKLA",
    line3: "İNŞA EDİYORUZ",
    subtitle:
      "Tabeladan LED ekrana, matbaadan e-ticarete, cephe giydirmeden prodüksiyona — 18 disiplini tek sanat yönetmenliği altında birleştiren stüdyo.",
    images: { main: IMAGES.heroMain, print: IMAGES.heroPrint, video: IMAGES.heroVideo },
  },
  marquee: [
    "Reklam", "Tabela", "LED Ekran", "Lightbox", "Baskı", "Matbaa", "Kartvizit",
    "Broşür", "DTF Tekstil", "Promosyon", "İnşaat", "İç Mekân", "Cephe Giydirme",
    "Dekorasyon", "Web Sitesi", "E-Ticaret", "Sosyal Medya", "Video & Fotoğraf",
  ],
  manifesto: {
    eyebrow: "Manifesto",
    titlePre: "Üç ilke.",
    titleGold: "Tek standart:",
    titlePost: "mükemmeliyet.",
    chapters: [
      { no: "01", title: "Kusursuz İşçilik", copy: "Kutu harf tabeladan altın yaldızlı kartvizite kadar her üretim, milimetrik hassasiyetle atölyemizde şekillenir. Detay, bizim standartlarımızda bir tercih değil; zorunluluktur." },
      { no: "02", title: "Bütünleşik Disiplin", copy: "Reklam, baskı, inşaat ve dijital: 18 disiplini tek sanat yönetmenliği altında birleştirir, tedarikçi koordinasyonunun tüm yükünü sizden alırız." },
      { no: "03", "title": "Zamanında Teslimat", copy: "Keşiften montaja, tasarımdan yayına; söz verdiğimiz tarihte, eksiksiz ve kusursuz teslim. Takvim bizim için bir vaattir." },
    ],
  },
  services: {
    eyebrow: "Hizmetlerimiz",
    titlePre: "Dört disiplin,",
    titleGold: "on sekiz uzmanlık",
    intro: "Bir kategori seçin; o disiplinin tüm hizmetlerini keşfedin ve tek dokunuşla teklif isteyin.",
    categories: [
      {
        id: "reklam-tabela", number: "01", title: "Reklam & Tabela",
        tagline: "Mekânsal görünürlük ve marka heykeltıraşlığı",
        services: [
          { name: "Reklam Stratejisi & Tasarım", desc: "Marka kimliğinizi üç boyutlu fiziksel dünyaya taşıyan ödüllük konsept tasarımlar." },
          { name: "Tabela Sistemleri", desc: "Kutu harf, krom, alüminyum kompozit ve totem tabela üretimi; keşiften montaja." },
          { name: "LED Ekran Çözümleri", desc: "Yüksek parlaklıklı iç ve dış mekân devasa dijital gösterge sistemleri." },
          { name: "Lightbox", desc: "İnce alüminyum kasalı, homojen LED aydınlatmalı kumaş ve vinil panolar." },
          { name: "Cephe Giydirme", desc: "Kompozit panel, cam giydirme ve folyo kaplama mimari uygulamalar." },
        ],
      },
      {
        id: "baski-matbaa", number: "02", title: "Baskı & Matbaa",
        tagline: "Dokunsal kalite ve yüksek hassasiyetli üretim",
        services: [
          { name: "Baskı Hizmetleri", desc: "Dijital ve ofset, yüksek çözünürlüklü her yüzeye baskı çözümleri." },
          { name: "Matbaa & Yayıncılık", desc: "Katalog, dergi, kurumsal dosya ve özel ciltleme teknikleri." },
          { name: "Kartvizit & Kurumsal Evrak", desc: "Altın yaldız, lak kaplama, kabartma ve özel dokulu premium kartvizitler." },
          { name: "Broşür & İnsert", desc: "Yüksek adetli promosyonel ve bilgilendirici katlamalı broşürler." },
          { name: "DTF Tekstil Baskı", desc: "Canlı renkli, yıkamaya dayanıklı doğrudan filme tekstil baskı teknolojisi." },
          { name: "Promosyon Ürünleri", desc: "Lazer kazımalı ajanda, kalem, powerbank ve premium hediyelikler." },
        ],
      },
      {
        id: "yapi-ic-mekan", number: "03", title: "Yapı & İç Mekân",
        tagline: "Mimari estetik ve fonksiyonel yaşam alanları",
        services: [
          { name: "Yapı ve İnşaat", desc: "Mağaza, ofis ve ticari alanların anahtar teslim inşaat süreçleri." },
          { name: "İç Mekân Tasarımı", desc: "3D render projelendirme ve lüks mekân optimizasyonu." },
          { name: "Dekorasyon & Uygulama", desc: "Özel üretim mobilya, ahşap-metal panel ve aydınlatma tasarımları." },
        ],
      },
      {
        id: "dijital-medya", number: "04", title: "Dijital & Medya",
        tagline: "Dijital evrende kusursuz varlık ve prodüksiyon",
        services: [
          { name: "Web Sitesi Tasarımı", desc: "Özel yazılımlı, yüksek hızlı ve animasyonlu elit kurumsal siteler." },
          { name: "E-Ticaret Sistemleri", desc: "Ödeme entegrasyonlu, mobil uyumlu, yüksek dönüşümlü satış platformları." },
          { name: "Sosyal Medya Yönetimi", desc: "İçerik planlama, kreatif tasarım ve reklam kampanyası yönetimi." },
          { name: "Profesyonel Video & Fotoğraf", desc: "Stüdyo ve saha çekimleri, drone çekimi, reklam filmi prodüksiyonu." },
        ],
      },
    ],
  },
  showcase: {
    eyebrow: "İşlerimiz",
    titlePre: "Işığın, baskının ve mekânın",
    titleGold: "buluştuğu işler",
    tiles: [
      { src: IMAGES.showcaseSignage, label: "Tabela & LED Ekran", span: "sm:col-span-2 sm:row-span-2" },
      { src: IMAGES.showcasePrint, label: "Matbaa & Yaldız", span: "" },
      { src: IMAGES.showcaseVideo, label: "Prodüksiyon", span: "" },
      { src: IMAGES.showcaseInterior, label: "İç Mekân Tasarımı", span: "sm:col-span-2" },
      { src: IMAGES.showcaseFacade, label: "Cephe Giydirme", span: "" },
      { src: IMAGES.showcaseOffice, label: "Yapı & Dekorasyon", span: "" },
    ],
  },
  contact: {
    eyebrow: "İletişim",
    titlePre: "Projenizi",
    titleGold: "konuşalım",
    intro: "Formu doldurun, talebiniz kayıtlarımıza düşsün; ya da tek dokunuşla WhatsApp üzerinden doğrudan ekibimize ulaşın. Keşif ve teklif tamamen ücretsizdir.",
    phone: "+90 545 827 61 05",
    email: "info@reyadesing.com",
    address: "Türkiye",
    whatsapp: "905458276105",
  },
  footer: {
    tagline: "Desing — Marka Mimarlığı",
    copyright: "© 2026 Reya Desing — Tüm hakları saklıdır",
    meta: "Reklam • Baskı • Yapı • Dijital",
  },
};
